import React from 'react';
import classNames from 'classnames';

import alertIcon from './assets/alert.svg';

const Alert = ({className}: {className?: string}) => {
  return (
    <div className={classNames(className, 'Alert')}>
      <img src={alertIcon} className="alertIcon" alt="warning" />
    </div>
  );
};

export default Alert;
